import { Flex, Image } from '@modusign/design-system';
import { useTranslation } from 'react-i18next';

import zoomInIcon from '@app/assets/icons/icon-zoom-in-white.svg';
import zoomOutIcon from '@app/assets/icons/icon-zoom-out-white.svg';
import HeaderButton from '@app/components/HeaderButton';

interface DocumentZoomButtonProps {
  disabled?: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
}

function DocumentZoomButton({ disabled, onZoomIn, onZoomOut }: DocumentZoomButtonProps) {
  const { t } = useTranslation();

  return (
    <Flex
      backgroundColor="transparent"
      color="white"
      height="44px"
      whiteSpace="nowrap"
      zIndex={500}
    >
      <HeaderButton
        ariaLabel="확대"
        disabled={disabled}
        tooltipMessage={t('DocumentHeader-zoomIn')}
        onClick={onZoomIn}
      >
        <Image
          alt="확대"
          src={zoomInIcon}
          sx={{
            margin: 0,
          }}
        />
      </HeaderButton>
      <HeaderButton
        ariaLabel="축소"
        disabled={disabled}
        tooltipMessage={t('DocumentHeader-zoomOut')}
        onClick={onZoomOut}
      >
        <Image
          alt="축소"
          src={zoomOutIcon}
          sx={{
            margin: 0,
          }}
        />
      </HeaderButton>
    </Flex>
  );
}

export default DocumentZoomButton;
